const checkUppercase = function (value) {
  if (/^[a-z]+$/.test(value)) {
    return true
  }
  return false
}

const checkUppercaseAndNumber = function(value) {
  if (/^[a-z\d]+$/.test(value)) {
    return true
  }
  return false
}

const checkPhone = function (value) {
  return /^\d{11}$/.test(value)
}
export default {
  checkUppercase,
  checkUppercaseAndNumber,
  checkPhone
}
